export default {
  state: {
    city: null,
    map: {}
  },
  getters: {
    getAsuddCity: state => state.city
  },
  mutations: {
    ASUDD_SET(state, [field, value]) {
      if (field.includes('.')) {
        const subField = field.split('.')
        state[subField[0]][subField[1]] = value
      } else {
        state[field] = value
      }
    }
  }
}
